import { z } from 'zod'

import { commonCommentFilterSchema } from '@/constants/common-comment-filter-schema'

const classesCommentFilterSchema = z.object({
  coursesId: z.array(z.string()).optional(),
  studentsId: z.array(z.string()).optional()
})

export const commentFilterSchema = classesCommentFilterSchema.merge(
  commonCommentFilterSchema
)

export type CommentFiltersKeys = keyof z.infer<typeof commentFilterSchema>
